<script setup lang="ts">
import { storeToRefs } from 'pinia'
import {
  NXGDSSelect,
  NXGDSSelectDropdownPositions,
  NXGDSSelectVariants,
} from '@nsftx/seven-nxg-design-system'
import { useCalculatorStore } from '@/stores/calculator/calculatorStore'

const { currency, currencyOptions } = storeToRefs(useCalculatorStore())
</script>

<template>
  <NXGDSSelect
    v-model="currency"
    :options="currencyOptions"
    :variant="NXGDSSelectVariants.box"
    icon="arrow-down-a"
    :dropdown-position="NXGDSSelectDropdownPositions.topRight"
    icon-position="right"
    placeholder="EUR"
  />
</template>
